export default {"src":"/_next/static/media/badminton.68bbb0e6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};